/**
 * @classdesc
 * Digitalisierungs-Modul-Auswahl-Panel.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCDigitize} options.module Modul-Instanz
 */
gc.gis.module.GCDigitize.SelectPanel = function(options)
{
	gc.gis.assert.isSet(options);
	gc.gis.assert.isInstance(options.module, gc.gis.module.GCDigitize);

	gc.gis.widget.GCPanel.call(this, options);

	/**
	 * @type {gc.gis.module.GCDigitize}
	 * @private
	 */
	this._module = options.module;

	/**
	 * Ausgewählter Layer-Modus für die Selektion.
	 * @type {number}
	 * @private
	 */
	this._layerSelectionMode = gc.gis.module.GCDigitizeConstants.SELECTION_LAYER_NONE;

	/**
	 * Ausgewählter Layer im Falle der Layer-Einzelauswahl.
	 * @type {gc.gis.layer.GCAbstractLayer}
	 * @private
	 */
	this._selectedLayer = undefined;

	this._render();
	this._initContent();
};
gc.gis.module.GCDigitize.SelectPanel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Liefert den aktuell eingestellten Layer-Auswahlmodus.
 *
 * @public
 * @method
 * @return {number}
 */
gc.gis.module.GCDigitize.SelectPanel.prototype.getLayerSelectionMode = function()
{
	return this._layerSelectionMode;
};

/**
 * Liefert den aktuell eingestellten Layer für die Einzellayer-Abfrage oder <code>undefined</code> fals kein Layer
 * ausgewählt wurde.
 *
 * @public
 * @method
 * @return {gc.gis.layer.GCAbstractLayer|undefined}
 */
gc.gis.module.GCDigitize.SelectPanel.prototype.getSelectedLayer = function()
{
	return this._selectedLayer;
};

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCDigitize.SelectPanel.prototype._initContent = function()
{
	var self = this;

	// Panel Inhalt
	var controls = [];

	controls[controls.length] = {
		label: 'Aus welcher Ebene soll ausgewählt werden?',
		name: 'digitize_select_layer',
		type: 'layer-selector',
		map: this._module.map,
		mode: gc.gis.widget.GCLayerSelectorMode.NONE
			| gc.gis.widget.GCLayerSelectorMode.SINGLE,
		sort: gc.gis.widget.GCLayerSelectorSort.ASCENDING,
		// TODO Filterung auf Vektodatenlayer korrigieren
		// selectLayerFilter: function(layer)
		// {
		// 	return !(layer instanceof gc.gis.layer.GCGroupLayer)
		// 		&& layer.isReallyVisible();
		// },
		change: function (evt, ctrl)
		{
			self._selectedLayer = undefined;

			var old_mode = self._layerSelectionMode;
			switch (ctrl.getMode())
			{
				case gc.gis.widget.GCLayerSelectorMode.VISIBLE:
					self._layerSelectionMode = gc.gis.module.GCDigitizeConstants.SELECTION_LAYER_VISIBLE;
					break;
				case gc.gis.widget.GCLayerSelectorMode.SELECTED:
					self._layerSelectionMode = gc.gis.module.GCDigitizeConstants.SELECTION_LAYER_SELECTED;
					break;
				case gc.gis.widget.GCLayerSelectorMode.ALL:
					self._layerSelectionMode = gc.gis.module.GCDigitizeConstants.SELECTION_LAYER_ALL;
					break;
				case gc.gis.widget.GCLayerSelectorMode.SINGLE:
					self._layerSelectionMode = gc.gis.module.GCDigitizeConstants.SELECTION_LAYER_SINGLE;
					self._selectedLayer = ctrl.getSingleLayerSelection();
					break;
				default:
					self._layerSelectionMode = gc.gis.module.GCDigitizeConstants.SELECTION_LAYER_NONE;
					break;
			}

			self._fireEvent(gc.gis.module.GCDigitizeEvent.SELECTION_LAYER_CHANGED, {
				old_mode: old_mode,
				new_mode: self._layerSelectionMode
			});
		}
	};

	var form_config = {
		controls: controls
		// validate: function(form, params) {},
		// submit: function(form, params) {},
		// error: function(form, err) {}
	};

	this.form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this.form.getElement());
};